module.exports = __webpack_public_path__ + "static/media/refwa_usa.4e0f9de2.png";